import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector:    'amd-table-list-button-header',
  templateUrl: './table-list-button-header.component.html',
  styleUrls:   ['./table-list-button-header.component.scss']
})
export class TableListButtonHeader implements OnInit {

  @Input() buttons?: IButtonsTableHeader[];
  
  constructor() { }

  ngOnInit() { }
}

export interface IButtonsTableHeader {
  type:           string,
  label:          string,
  class:          string,
  disabled:       () => boolean,
  visible:        () => boolean,
  container:      { class: string },
  eventListener:  { click: () => void },
}